import { useTranslation } from 'react-i18next';

import { ScTerms } from './styled';

interface TermsProps {
  terms: string[];
  translation?: string;
  handleScroll?: () => void;
}

export const Terms = ({ terms, handleScroll }: TermsProps) => {
  const { t } = useTranslation('common');

  return (
    <ScTerms>
      <div className="term">
        <div className="term__head" onClick={handleScroll}>
          {t('button.termsAndConditions')}
        </div>
        <div className="term__body">
          <ol>
            {terms.map((term, index) => (
              <li key={index}>{term}</li>
            ))}
          </ol>
        </div>
      </div>
    </ScTerms>
  );
};
